import SelfServiceBorne from '../Components/Borne/SelfServiceBorne';

/**
 * /self-service — borne tactile publique (sans authentification JWT).
 * L'identité de la borne est portée par son ApiKey (X-Borne-Key), acquise
 * via le flow de pairing. Design PWA plein écran, parcours tactile simple.
 */
const SelfService = () => <SelfServiceBorne />;

export default SelfService;
